import React, { useState } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import RoomService from "../../service/rooms-service";

import { Box, Col, InputBox, Button, Text, VGap, HRLine } from "../../comps";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { Theme } from "../../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
  overflow-y: hidden;
  overflow-x: hidden;
  background: ${({ theme }) => theme.color.GRAY_3};
`;

const Head = styled(Col)`
  width: 100%;
  height: 50px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.BLUE_4};
`;

const InputWrapper = styled(Box)`
  width: 90%;
  height: 40px;
`;

export default ({ close }) => {
  const [roomId, setRoomId] = useState(null);
  const inputFieldId = "dmvdf8";

  const handleJoin = async () => {
    const inputEle = document.getElementById(inputFieldId);
    const val = inputEle.value;
    const newRoomId = await RoomService.joinRoom({ roomId: val });
    if (newRoomId) setRoomId(newRoomId);
    close();
  };

  if (roomId) return <Redirect push to={`/room/${roomId}`} />;

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >{`Enter Room Id to join`}</Text>
      </Head>
      <VGap height="30px" />
      <InputWrapper>
        <InputBox
          id={inputFieldId}
          fontSize="14px"
          placeholder="Room ID"
          background={Theme.color.GRAY_3}
        />
      </InputWrapper>
      <VGap height="30px" />
      <Button
        height="30px"
        width="30%"
        buttonName="Join"
        buttonBackground={Theme.color.BLUE_4}
        borderRadius="5px"
        buttonIcon={faUsers}
        onClick={handleJoin}
      />
    </Wrapper>
  );
};
